import { createSelector } from 'reselect'
import scanSelector from './scan_selector'

const completedScanSelector = (state) => scanSelector(state)
const getVisibleScanRecords = (scans) =>
  scans.filter((scan) => scan.get('visibility') === 'visible').reverse()

export default createSelector(completedScanSelector, getVisibleScanRecords)
